import { DeepPartial, SearchBoxConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_SEARCH_BOX_CONFIG: DeepPartial<SearchBoxConfig> = {
  components: {
    icon: null,
    clearButtonContent: 'GoccoSearchBoxClear'
  },
  autoCompleteEnabled: false,
  autofocus: true
};
